import { GoogleAnalytics4EventNames } from '../../AnalyticsEventNames';
import AnalyticsEvent from './AnalyticsEvent';

class PaymentInfo extends AnalyticsEvent {
/**
   * @param {Object} paymentInfo
   * @param {Array.<AnalyticsItem>} paymentInfo.productList
   * @param {string} paymentInfo.currencyCode
   * @param {number} paymentInfo.value
   */
  sendPaymentInfoEvent({ productList, currencyCode, value }) {
    const { campaignCodeStore, checkoutStore } = this.rootStore;
    const activeCoupon = campaignCodeStore.activeCoupon;
    const coupon = activeCoupon && !activeCoupon.hasProductLimitations && activeCoupon || null;
    const order = checkoutStore.order;

    const data = {
      ecommerce: {
        coupon,
        currency: currencyCode,
        payment_type: order?.selected_payment?.method?.name || null,
        value,
        items: productList.map((item) => this.item.analyticsItemToItem({
          product: item,
          quantity: item.quantity,
          activeProductId: item.id,
        }, true)
        ),
      },
    };

    this.dataLayer.pushEventToDataLayer(
      data,
      GoogleAnalytics4EventNames.addPaymentInfo,
    );
  }
}

export default PaymentInfo;
